import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const HIGHLIGHT_DURATION_MS = 3000;

interface UseDeepLinkResult {
  commentId: string | null;
  highlightActive: boolean;
}

/**
 * useDeepLink reads the `?highlight` query param and manages a timed highlight
 * state that activates for 3 seconds after the page loads.
 *
 * Usage:
 *   const { commentId, highlightActive } = useDeepLink();
 */
export const useDeepLink = (): UseDeepLinkResult => {
  const [searchParams] = useSearchParams();
  const commentId = searchParams.get("highlight");

  const [highlightActive, setHighlightActive] = useState(false);

  useEffect(() => {
    if (!commentId) return;

    setHighlightActive(true);
    const timer = setTimeout(() => {
      setHighlightActive(false);
    }, HIGHLIGHT_DURATION_MS);

    return () => clearTimeout(timer);
  }, [commentId]);

  return { commentId, highlightActive };
};
